module.exports = {"title":"Facebook","connectAccountCta":"Connect to Facebook","connectInfo":"Want to connect your Facebook account to a 1stdibs account?","connectInfoCta":"Learn how","disconnectAccountCta":"Disconnect account","changeAccountInfo":"Want to connect your Facebook account to a different 1stdibs account?","infoCtaUrl":"https://support.1stdibs.com/s/article/ka00L000000D3TCQA0/Logging-in-with-Your-Social-Account"}


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/components/Facebook/facebookAccountCopy.json
// module id = 2748
// module chunks = 63